<script setup lang="ts">
defineProps({ blok: Object })
</script>

<template>
    <section class="section">
        <UiContainer>
            <header class="mb-8">
                <h2 class="font-londrina-solid text-chsc-indigo-500 fs-8xl">
                    {{ blok?.title }}
                </h2>
            </header>
            <div class="grid grid-cols-12 gap-x-12 max-[769px]:grid-cols-1 max-[769px]:gap-x-0 max-[769px]:gap-y-4">
                <div class="col-span-5">
                    <div class="global-text">
                        <StoryblokRichText :doc="blok?.header" />
                    </div>
                    <div class="mt-8">
                        <img
                            v-motion-slide-left
                            :src="blok?.people.filename"
                            :alt="blok?.people.alt"
                            class="max-[769px]:hidden"
                        >
                    </div>
                </div>
                <div class="col-span-7">
                    <div class="global-text">
                        <StoryblokRichText :doc="blok?.description" />
                    </div>
                    <div class="mt-8 grid grid-cols-2 gap-4 items-center max-[641px]:grid-cols-1 max-[641px]:gap-x-0 max-[641px]:gap-y-6">
                        <div
                            v-for="item in blok?.partners"
                            :key="item._uid"
                            class="flex justify-center items-center"
                        >
                            <img
                                :src="item.filename"
                                :alt="item.alt"
                            >
                        </div>
                    </div>
                </div>
            </div>
        </UiContainer>
    </section>
</template>
